//Custo css import
import './style.css'
import { Receipt } from 'lucide-react';

//React import
import { useContext, useEffect, useRef, useState } from 'react';

//Controller import
import ModalBtn from '../../molecules/modalButton/view';
import ButtonLoading from '../../atoms/buttonLoading/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { createSpend, createSpendWithSupportDocument } from '../../../usecases/spend-usecase';
import TabSwitcher from '../../molecules/TabSwitcher/view';
import PaymentMethodSelector from '../../molecules/PaymentMethodSelector/view';

import ClientInfo from '../../atoms/ClientInfo/view';
import ServiceLineInput from '../../molecules/ServiceLineInput/view';

import { formatMoney } from '../../../utils/formating';

import { roleContext } from '../../../context/role/context';
import DateSelector from '../../atoms/datepicker/view';


function NewSpend({ id }) {

    const { isElectronicInvoiceEnable, uid, cid } = useContext(roleContext)

    const [formData, setFormData] = useState(undefined)
    const [selectedMethods, setSelectedMethods] = useState([])
    const [selectedFormPay, setSelectedFormPay] = useState(undefined)
    const [tercero, SetTercero] = useState(undefined)
    const [serviceLines, setServiceLines] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [balance, setBalance] = useState(0);
    const [totalRetention, setTotalRetention] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [spendDate, setSpendDate] = useState(new Date());
    const [xmlInvoiceData, setXmlInvoiceData] = useState(null);

    // Flag para indicar que la apertura viene del flujo XML y no debe resetear el estado
    const isOpenFromXml = useRef(false);


    const tabs = [
        {
            name: "Gasto",
            component: () => (
                <div className='form-spends' id="spend-form" action="javascript:void(0);">
                    <div style={{ marginBottom: '15px' }}>
                        <p style={{ margin: '0 0 5px 0', fontSize: '14px', fontWeight: 'bold' }}>Fecha del Gasto</p>
                        <DateSelector
                            label="Seleccionar fecha"
                            date={spendDate}
                            onChange={(date) => setSpendDate(date)}
                        />
                    </div>
                    <ClientInfo tercero={tercero} type={'provider'}></ClientInfo>
                    <ServiceLineInput onServiceLinesChange={(lines) => handleServiceLine(lines)} serviceLines={serviceLines} />
                    <br></br>
                    <div className='spend-summary-box'>
                        <p>Total Bruto: <span>{formatMoney(totalAmount)}</span></p>
                        <p>Impuestos: <span>{formatMoney(totalTax)}</span></p>
                        <p style={{ color: 'red' }}>Retenciones: <span>-{formatMoney(totalRetention)}</span></p>
                        <hr />
                        <p><strong>Total a Pagar: <span>{formatMoney(subtotal)}</span></strong></p>
                    </div>
                    <PaymentMethodSelector
                        id="spend-payment-methods"
                        onSelectMethod={handlePayMethods}
                        onAmountChange={handlePayMethods}
                        onRemoveMethod={handlePayMethods}
                        defaultAmount={subtotal}
                    />
                    <br></br>
                    {!tercero && serviceLines.length > 0 && (
                        <p style={{ color: '#e74c3c', fontSize: '13px', textAlign: 'center', marginBottom: '8px', fontWeight: '600' }}>
                            * Selecciona un Proveedor arriba para habilitar la creación del gasto.
                        </p>
                    )}
                    <ButtonLoading
                        id="spend-create"
                        title={"Crear Gasto"}
                        onClick={onSubmitSpend}
                        disabled={serviceLines.length === 0 || !tercero || balance != 0 || selectedMethods.length === 0}
                    />
                </div>
            )
        },
        {
            name: "Documentos Soporte",
            disabled: !isElectronicInvoiceEnable,
            component: () => (
                <div className='form-spends' id="spend-form" action="javascript:void(0);">
                    <div style={{ marginBottom: '15px' }}>
                        <p style={{ margin: '0 0 5px 0', fontSize: '14px', fontWeight: 'bold' }}>Fecha del Gasto</p>
                        <DateSelector
                            label="Seleccionar fecha"
                            date={spendDate}
                            onChange={(date) => setSpendDate(date)}
                        />
                    </div>
                    <ClientInfo tercero={tercero} type={'provider'}></ClientInfo>
                    <ServiceLineInput onServiceLinesChange={(lines) => handleServiceLine(lines)} serviceLines={serviceLines} />
                    <br></br>
                    <div className='spend-summary-box'>
                        <p>Total Bruto: <span>{formatMoney(totalAmount)}</span></p>
                        <p>Impuestos: <span>{formatMoney(totalTax)}</span></p>
                        <p style={{ color: 'red' }}>Retenciones: <span>-{formatMoney(totalRetention)}</span></p>
                        <hr />
                        <p><strong>Total a Pagar: <span>{formatMoney(subtotal)}</span></strong></p>
                    </div>
                    <PaymentMethodSelector
                        id="spend-payment-methods"
                        onSelectMethod={handlePayMethods}
                        onAmountChange={handlePayMethods}
                        onRemoveMethod={handlePayMethods}
                        enableFormPay={true}
                        selectedFormPay={setSelectedFormPay}
                        defaultAmount={subtotal}
                    />
                    <br></br>
                    {!tercero && serviceLines.length > 0 && (
                        <p style={{ color: '#e74c3c', fontSize: '13px', textAlign: 'center', marginBottom: '8px', fontWeight: '600' }}>
                            * Selecciona un Proveedor arriba para habilitar la creación del gasto.
                        </p>
                    )}
                    <ButtonLoading
                        id="spend-doc-create"
                        title={"Crear Gasto"}
                        onClick={onSubmitSpendWithDoc}
                        disabled={serviceLines.length === 0 || !tercero || balance != 0 || !selectedFormPay || selectedMethods.length === 0}
                    />
                </div>
            )
        }
    ];

    useEffect(() => {
        const cleanupThirds = listener('btn-thirds-add', (e) => { handleAddThird(e.detail.data) });
        const cleanupXmlData = listener('open-new-spend-with-data', (e) => {
            // dispatchCustomEvent wraps payload as { eventKey, data: payload }
            const data = e.detail?.data;
            if (data) {
                if (data.tercero) {
                    handleAddThird(data.tercero);
                }
                if (data.serviceLines) {
                    handleServiceLine(data.serviceLines);
                }
                if (data.xmlInvoiceData) {
                    setXmlInvoiceData(data.xmlInvoiceData);
                }
                if (data.issueDate) {
                    // Try to parse the date string (e.g. YYYY-MM-DD)
                    const parsedDate = new Date(data.issueDate + 'T12:00:00Z');
                    if (!isNaN(parsedDate.getTime())) {
                         setSpendDate(parsedDate);
                    }
                }
                // Marcar que la apertura viene del XML para evitar que handleOpen resetee el estado
                isOpenFromXml.current = true;
                // Open modal programmatically
                document.getElementById("modal-btn-basic-newSpend-" + (id || 'undefined'))?.click();
            }
        });
        return () => {
            cleanupThirds();
            cleanupXmlData();
        };
    }, [id]);

    function handleOpen() {
        // Si la apertura viene del flujo XML, no resetear el estado pre-cargado
        if (isOpenFromXml.current) {
            isOpenFromXml.current = false;
            setFormData({});
            return;
        }
        setFormData({});
        setXmlInvoiceData(null);
        setServiceLines([]);
        setSelectedMethods([]);
        setSelectedFormPay(undefined);
        setTotalAmount(0);
        setTotalTax(0);
        setTotalRetention(0);
        setSubtotal(0);
        setBalance(0);
        setSpendDate(new Date());
    }

    function handleAddThird(third) {
        SetTercero(third)
    }

    function onSubmitSpend() {
        if (serviceLines.length === 0) {
            dispatchCustomEvent("popup", { message: "Debe agregar al menos una línea de servicio.", type: "warning" });
            return;
        }
        if (selectedMethods.length === 0) {
            dispatchCustomEvent("popup", { message: "Debe agregar al menos un medio de pago.", type: "warning" });
            return;
        }
        if (!tercero) {
            dispatchCustomEvent("popup", { message: "Debe seleccionar un tercero.", type: "warning" });
            return;
        }

        formData["payment_methods"] = selectedMethods;
        formData["tercero"] = tercero;
        formData["service_lines"] = serviceLines;
        formData["retention"] = totalRetention;
        formData["spend_date"] = spendDate;
        if (xmlInvoiceData) {
            formData["xml_invoice_data"] = JSON.stringify(xmlInvoiceData);
        }

        createSpend(formData).then((res) => {
            dispatchCustomEvent("close-newSpend-" + id + "-modal", [])
            dispatchCustomEvent("popup", { message: "Gasto creado correctamente", type: "success" })
            dispatchCustomEvent("reload-spends", res)
            dispatchCustomEvent("loading-btn-spend-create", null)
            dispatchCustomEvent("close-newSpend-" + id + "-modal", [])
            handleOpen()
        }).catch((error) => {
            console.error("Error creating spend:", error);
            const err = error?.response?.data?.error || error?.response?.data?.message;
            const messages = {
                "bad_request": "Solicitud inválida. Verifique los datos.",
                "Error creando gasto debido a un problema de integridad de datos.": "Error de integridad de datos al crear el gasto.",
            };
            const displayMessage = messages[err] || err || error?.message || "Error al crear gasto";
            dispatchCustomEvent("popup", { message: displayMessage, type: "error" });
            dispatchCustomEvent("loading-btn-spend-create", null);
        });
    }

    async function onSubmitSpendWithDoc() {
        if (serviceLines.length === 0) {
            dispatchCustomEvent("popup", { message: "Debe agregar al menos una línea de servicio.", type: "warning" });
            return;
        }
        if (!tercero) {
            dispatchCustomEvent("popup", { message: "Debe seleccionar un tercero.", type: "warning" });
            return;
        }
        if (!selectedFormPay) {
            dispatchCustomEvent("popup", { message: "Debe seleccionar una forma de pago.", type: "warning" });
            return;
        }

        formData["payment_methods"] = selectedMethods.map(method => ({
            ...method,
            payment_form_id: selectedFormPay
        }));
        formData["tercero"] = tercero;
        formData["service_lines"] = serviceLines;
        formData["retention"] = totalRetention;
        formData["spend_date"] = spendDate;
        if (xmlInvoiceData) {
            formData["xml_invoice_data"] = JSON.stringify(xmlInvoiceData);
        }


        try {
            // Un solo llamado atómico: guarda el gasto Y emite el DS en el back
            const result = await createSpendWithSupportDocument(formData);

            dispatchCustomEvent("close-newSpend-" + id + "-modal", []);
            dispatchCustomEvent("popup", { message: "Gasto y Documento Soporte creados correctamente", type: "success" });
            dispatchCustomEvent("reload-spends", result);
            dispatchCustomEvent("loading-btn-spend-doc-create", null);
            handleOpen();
        } catch (error) {
            const err = error?.response?.data?.error;
            const messages = {
                "bad_request": "Solicitud inválida. Verifique los datos.",
                "VALIDATION_ERROR": "Error de validación. Verifique los datos del gasto.",
            };
            const msg = error?.response?.data?.message || messages[err] || error?.message || "Error al crear gasto con documento soporte";
            dispatchCustomEvent("popup", { message: msg, type: "error" });
            dispatchCustomEvent("loading-btn-spend-doc-create", null);
        }
    }

    function handleServiceLine(serviceLines) {
        let lines = serviceLines.map(line => {
            const spendType = line.spend_type_data || {};
            const amount = Math.round(line.amount || 0);
            const taxRate = ('tax' in spendType && (spendType.tax === null || spendType.tax?.disabled)) ? 0 : (spendType.tax?.value || 0);
            const retRate = ('retention' in spendType && (spendType.retention === null || spendType.retention?.disabled)) ? 0 : (spendType.retention?.value || 0);
            var tax = Math.round(amount - (amount / (1 + taxRate)));
            var base = amount - tax;
            var ret = Math.round(base * retRate);
            return {
                ...line,
                amount: amount,
                tax: tax,
                base: base,
                retention: ret,
            };
        });

        let gross = Math.round(lines.reduce((sum, line) => sum + (line.amount || 0), 0));
        let ret = Math.round(lines.reduce((sum, line) => sum + (line.retention || 0), 0));
        let taxes = Math.round(lines.reduce((sum, line) => sum + (line.tax || 0), 0));
        let net = gross - ret;

        setTotalAmount(gross);
        setTotalTax(taxes);
        setTotalRetention(ret);
        setSubtotal(net);
        setServiceLines(lines);
    }

    function handlePayMethods(methods) {
        let money = methods.reduce((sum, method) => sum + (method.value || 0), 0);
        let balance = Math.round(subtotal - money);
        setBalance(balance);
        setSelectedMethods(methods);
    }

    return (
        <ModalBtn
            id={"newSpend-" + (id || 'undefined')}
            title="Nuevo Gasto"
            icon={<Receipt size={20} />}
            onClick={handleOpen}
        >
            <TabSwitcher tabs={tabs}></TabSwitcher>
        </ModalBtn>
    )
}

export default NewSpend
